import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  notes: {
    description: 'orderDrawer.notes.notes',
    defaultMessage: 'Notes',
    id: 'COyieb',
  },
});
